import { defineMessages } from 'react-intl';

export default defineMessages({
  relatedCourses: {
    id: 'Related Courses',
    defaultMessage:
      '{counter, plural, one {Related course} other {Related courses}}',
  },
  onlineAndAtYourOwnPace: {
    id: 'Online and at your own pace',
    defaultMessage: 'Online and at your own pace',
  },
  disc: {
    id: 'Disc.',
    defaultMessage: 'Disc.',
  },
  aCourseBy: {
    id: 'A course by',
    defaultMessage: 'A course by',
  },
  and: {
    id: 'and',
    defaultMessage: 'and',
  },
  topSales: {
    id: 'Top sales',
    defaultMessage: 'Top sales',
  },
  moreInformation: {
    id: 'More Information',
    defaultMessage: 'More Information',
  },
});
